var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"widget-1",attrs:{"bordered":false}},[_c('a-statistic',{staticClass:"text-success",class:'text-' + _vm.status,attrs:{"title":_vm.title,"value":_vm.value,"prefix":_vm.prefix,"suffix":_vm.suffix,"precision":_vm.precision}}),_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icon)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }